module.exports = __webpack_public_path__ + "img/complyon-light-logo-text.10db9039.svg";